import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, {} from 'react';
import { ExclamationOutlined } from '@ant-design/icons';
import { Avatar, Flex, Typography } from 'antd';
const ErrorList = ({ title, subTitle, errors }) => {
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: title }), _jsx("p", { children: subTitle }), _jsx(Flex, { vertical: true, gap: 8, children: errors.map(error => (_jsxs(Flex, { gap: 8, children: [_jsx(Avatar, { style: { color: '#000', backgroundColor: '#f04d3e' }, shape: "square", icon: _jsx(ExclamationOutlined, {}) }), _jsx(Typography.Text, { children: error })] }))) })] }));
};
export default ErrorList;
